import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wmsm',
  templateUrl: './WMSM.component.html',
  styleUrls: ['./WMSM.component.css']
})
export class WMSMComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
